import { EStorageType } from '@/_utils/_types';

type TParams = {
  storageType?: EStorageType;
};

export const getStorageByType = ({ storageType }: TParams): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (storageType === EStorageType.sessionStorage) {
    return sessionStorage;
  }

  if (storageType === EStorageType.localStorage) {
    return localStorage;
  }

  return localStorage;
};
